import {forwardRef} from "react";
import {clsx} from "clsx";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | undefined;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {label, error, helperText, leftIcon, rightIcon, className = "", ...props},
    ref
  ) => {
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={props.id || props.name} className="form-label">
            {label}
          </label>
        )}

        <div className="relative">
          {leftIcon && (
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <div className="text-gray-400 dark:text-gray-500">{leftIcon}</div>
            </div>
          )}

          <input
            ref={ref}
            {...props}
            className={clsx(
              "form-input",
              leftIcon && "pl-10",
              rightIcon && "pr-10",
              error &&
                "border-danger-500 focus:border-danger-500 focus:ring-danger-500",
              className
            )}
            onChange={(e) => {
              props.onChange?.(e);
            }}
            onBlur={(e) => {
              props.onBlur?.(e);
            }}
          />

          {rightIcon && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
              <div className="text-gray-400 dark:text-gray-500">
                {rightIcon}
              </div>
            </div>
          )}
        </div>

        {error && <p className="form-error">{error}</p>}

        {helperText && !error && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
export default Input;
